import 'src/styles/ui/attachment-row.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import iconNode from 'src/components/ui/iconNode';

/**
 * A saved file/attachment preview row: a thumbnail (or type icon), the file
 * name + a subtitle, and an optional actions row (e.g. replace / delete). When
 * `viewable` + `onView` are set the row itself becomes a button that opens the
 * file. Generic: usable anywhere a stored upload is shown. `icon` accepts a
 * FontAwesome definition or a node.
 */
const AttachmentRow = ({
  thumbnail,
  icon,
  name,
  sub,
  viewable,
  onView,
  actions,
  className,
  ...props
}) => {
  const interactive = Boolean(viewable && onView);
  return (
    <>
      <div
        className={classNames('attachment', { 'attachment--viewable': interactive }, className)}
        role={interactive ? 'button' : undefined}
        tabIndex={interactive ? 0 : undefined}
        onClick={interactive ? onView : undefined}
        onKeyDown={
          interactive
            ? event => {
                if (event.key === 'Enter' || event.key === ' ') onView();
              }
            : undefined
        }
        {...props}
      >
        {thumbnail ? (
          <img src={thumbnail} alt='' className='attachment__thumb' />
        ) : (
          icon != null && <span className='attachment__icon'>{iconNode(icon)}</span>
        )}
        <div className='attachment__body'>
          <div className='attachment__name'>{name}</div>
          {sub != null && <div className='attachment__sub'>{sub}</div>}
        </div>
      </div>
      {actions != null && <div className='attachment__actions'>{actions}</div>}
    </>
  );
};

AttachmentRow.propTypes = {
  thumbnail: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  name: PropTypes.node.isRequired,
  sub: PropTypes.node,
  viewable: PropTypes.bool,
  onView: PropTypes.func,
  actions: PropTypes.node,
  className: PropTypes.string,
};

AttachmentRow.defaultProps = {
  thumbnail: null,
  icon: null,
  sub: null,
  viewable: false,
  onView: null,
  actions: null,
  className: '',
};

export default AttachmentRow;
